import { createActions, createReducer } from "reduxsauce";

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    setSubcontractorList: [],
    setSubcontractorFilter: [],
    cleanSubcontractorList: [],
    setSubcontractorLoading: [],
    setSelectedSubcontractor: [],
    unsetSelectedSubcontractor: [],
    setFetchedSubcontractorDetails: [],
    setGetSubcontractor: [],
    setSubcontractorToast: [],
    setSelectedSubcontractorInvoice: [],
    unsetSelectedSubcontractorInvoice: [],
    setFetchedSubcontractorInvoiceDetails: [],
    setSubcontractorOptions: [],
    setFetchedSubcontractorsNotLinkedProvider: [],
    setFetchedSubcontractorsByProvider: [],
    setReloadSubcontractorList: [],
    setLoadingSubcontractorsByProvider: [],
    setLoadingSubcontractorsNotLinkedProvider: [],
    setEditInvoiceId: [],
    setSubcontractorInvoiceByOrderList: [],
    setSubcontractorByIdLoading: []
});
 
/**
 * Handlers
 */
const INITIAL_STATE = {
    subcontractorList: [],
    isLoading: false,
	listHasMore: true,
	listPage: 0,
    filter: {
        cnpj: '',
		email: '',
		nomeFantasia: '',
		razaoSocial: '',
	},
    selectedSubcontractor: {
        id: null,
        data: {}
    },
    selectedSubcontractorInvoice: {
        id: null,
        data: {}
    },
    subcontractorToast: {
        showToast: false,
        message: '',
        messageType: 'toast-success'
    },
    fetchedSubcontractorDetails: {},
    fetchedSubcontractorInvoiceDetails: {},
    getSubcontractor: null,
    getSubcontractorInvoice: null,
    providerSubcontractorList: [],
    enableNextButton: false,
    fetchedSubcontractorsNotLinkedProvider: {
        buscarSubcontratadoNaoVinculadoAoFornecedor: [],
        loading: false
    },
    fetchedSubcontractorsByProvider: {
        buscarSubcontratadoPorFornecedor: [],
        loading: false,
        reloadSubcontractorList: 0
    },
    editInvoiceId: null,
    subcontractorInvoiceByOrderList: [],
    isLoadingById: false
};
 
const setSubcontractorList = (state = INITIAL_STATE, action) => {
    return { 
        ...state, 
        subcontractorList: state.subcontractorList.concat(action.payload.list),
        listHasMore: action.payload.hasMore,
        listPage: action.payload.page
    };
}

const setSubcontractorFilter = (state = INITIAL_STATE, action) => {
    return { ...state, filter: action.payload };
}

const cleanSubcontractorList = (state = INITIAL_STATE, action) => {
    return { ...state, subcontractorList: [] };
}

const setSubcontractorLoading = (state = INITIAL_STATE, action) => {
    return { ...state, isLoading: action.payload };
}

const setSelectedSubcontractor = (state = INITIAL_STATE, action) => {
    return { ...state, selectedSubcontractor: action.payload };
}

const unsetSelectedSubcontractor = (state = INITIAL_STATE, action) => {
    return { ...state, selectedSubcontractor: action.payload };
}

const setFetchedSubcontractorDetails = (state = INITIAL_STATE, action) => {
    return { ...state, fetchedSubcontractorDetails: action.payload };
}

const setGetSubcontractor = (state = INITIAL_STATE, action) => {
    return { ...state, getSubcontractor: action.payload };
}

const setSubcontractorToast = (state = INITIAL_STATE, action) => {
    return {
        ...state, 
        subcontractorToast: {
            showToast: action.payload.showToast,
            message: action.payload.message,
            messageType: action.payload.messageType
        }
    };
}

const setSelectedSubcontractorInvoice = (state = INITIAL_STATE, action) => {
    return { ...state, selectedSubcontractorInvoice: action.payload };
}

const unsetSelectedSubcontractorInvoice = (state = INITIAL_STATE, action) => {
    return { ...state, selectedSubcontractorInvoice: action.payload };
}

const setFetchedSubcontractorInvoiceDetails = (state = INITIAL_STATE, action) => {
    return { ...state, fetchedSubcontractorInvoiceDetails: action.payload };
}

const setSubcontractorOptions = (state = INITIAL_STATE, action) => {
    return { ...state, providerSubcontractorList: action.payload };
}

const setFetchedSubcontractorsNotLinkedProvider = (state = INITIAL_STATE, action) => {
    var list = action.payload;
    list.unshift({id: -1, nomeFantasia: '--- Selecione um Subcontratado'});
    return { ...state, fetchedSubcontractorsNotLinkedProvider: { buscarSubcontratadoNaoVinculadoAoFornecedor: list }};
}

const setFetchedSubcontractorsByProvider = (state = INITIAL_STATE, action) => {
    return { ...state, fetchedSubcontractorsByProvider: { ...state.fetchedSubcontractorsByProvider, buscarSubcontratadoPorFornecedor: action.payload } }
}

const setReloadSubcontractorList = (state = INITIAL_STATE, action) => {
    return { ...state, fetchedSubcontractorsByProvider: { ...state.fetchedSubcontractorsByProvider, reloadSubcontractorList: state.fetchedSubcontractorsByProvider.reloadSubcontractorList + 1 } };
}

const setLoadingSubcontractorsByProvider = (state = INITIAL_STATE, action) => {
    return { ...state, fetchedSubcontractorsByProvider: { ...state.fetchedSubcontractorsByProvider, loading: action.payload } };
}

const setLoadingSubcontractorsNotLinkedProvider = (state = INITIAL_STATE, action) => {
    return { ...state, fetchedSubcontractorsByProvider: { ...state.fetchedSubcontractorsByProvider, loading: action.payload } };
}

const setEditInvoiceId = (state = INITIAL_STATE, action) => {
    return { ...state, editInvoiceId: action.payload };
}

const setSubcontractorInvoiceByOrderList = (state = INITIAL_STATE, action) => {
    return { ...state, subcontractorInvoiceByOrderList: action.payload };
}

const setSubcontractorByIdLoading = (state = INITIAL_STATE, action) => {
    return { ...state, isLoadingById: action.payload };
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.SET_SUBCONTRACTOR_LIST]: setSubcontractorList,
    [Types.SET_SUBCONTRACTOR_FILTER]: setSubcontractorFilter,
    [Types.CLEAN_SUBCONTRACTOR_LIST]: cleanSubcontractorList,
    [Types.SET_SUBCONTRACTOR_LOADING]: setSubcontractorLoading,
    [Types.SET_SELECTED_SUBCONTRACTOR]: setSelectedSubcontractor,
    [Types.UNSET_SELECTED_SUBCONTRACTOR]: unsetSelectedSubcontractor,
    [Types.SET_FETCHED_SUBCONTRACTOR_DETAILS]: setFetchedSubcontractorDetails,
    [Types.SET_GET_SUBCONTRACTOR]: setGetSubcontractor,
    [Types.SET_SUBCONTRACTOR_TOAST]: setSubcontractorToast,
    [Types.SET_SELECTED_SUBCONTRACTOR_INVOICE]: setSelectedSubcontractorInvoice,
    [Types.UNSET_SELECTED_SUBCONTRACTOR_INVOICE]: unsetSelectedSubcontractorInvoice,
    [Types.SET_FETCHED_SUBCONTRACTOR_INVOICE_DETAILS]: setFetchedSubcontractorInvoiceDetails,
    [Types.SET_SUBCONTRACTOR_OPTIONS]: setSubcontractorOptions,
    [Types.SET_FETCHED_SUBCONTRACTORS_NOT_LINKED_PROVIDER]: setFetchedSubcontractorsNotLinkedProvider,
    [Types.SET_FETCHED_SUBCONTRACTORS_BY_PROVIDER]: setFetchedSubcontractorsByProvider,
    [Types.SET_RELOAD_SUBCONTRACTOR_LIST]: setReloadSubcontractorList,
    [Types.SET_LOADING_SUBCONTRACTORS_BY_PROVIDER]: setLoadingSubcontractorsByProvider,    
    [Types.SET_LOADING_SUBCONTRACTORS_NOT_LINKED_PROVIDER]: setLoadingSubcontractorsNotLinkedProvider,
    [Types.SET_EDIT_INVOICE_ID]: setEditInvoiceId,
    [Types.SET_SUBCONTRACTOR_INVOICE_BY_ORDER_LIST]: setSubcontractorInvoiceByOrderList,
    [Types.SET_SUBCONTRACTOR_BY_ID_LOADING]: setSubcontractorByIdLoading,
});
 